import { SocialContainer, SocialInner, SocialButton, Copyright } from './styled'

import { IconFacebook } from '../icons/facebook'
import { IconInstagram } from '../icons/instagram'
import { IconRss } from '../icons/rss'
import { IconTelegram } from '../icons/telegram'
import { IconTwitter } from '../icons/twitter'
import { IconYoutube } from '../icons/youtube'
export const socialURLs = [
  {
    title: 'facebook',
    icon: <IconFacebook />,
    url: 'http://facebook.com/currenttimetv',
  },
  {
    title: 'twitter',
    icon: <IconTwitter />,
    url: 'https://twitter.com/CurrentTimeTv',
  },
  {
    title: 'youtube',
    icon: <IconYoutube />,
    url: 'https://www.youtube.com/user/currenttimetv',
  },
  {
    title: 'instagram',
    icon: <IconInstagram />,
    url: 'https://www.instagram.com/currenttime.tv/',
  },
  {
    title: 'telegram',
    icon: <IconTelegram />,
    url: 'https://telegram.me/currenttime',
  },
  {
    title: 'rss',
    icon: <IconRss />,
    url: 'https://www.currenttime.tv/rssfeeds',
  },
]
export const SocialMedia = () => {
  return (
    <SocialContainer>
      <SocialInner>
        {socialURLs.map(item => (
          <SocialButton key={item.title} target="_blank" href={item.url}>
            {item.icon}
          </SocialButton>
        ))}
      </SocialInner>
      <Copyright>
        ©{new Date().getFullYear().toString()} Настоящее Время. Все права
        защищены
      </Copyright>
    </SocialContainer>
  )
}
